import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: [
                'footnote',
                'caption',
                'label',
                'note',
                'note-paragraph',
                'body',
                'body-paragraph',
                'headline',
                'headline-m',
                'headline-l',
                'headline-xl',
            ],
        },
    },
});

export const cn = (...inputs: ClassValue[]) => {
    return twMerge(clsx(inputs));
};
